import $ from 'jquery'
import _debounce from 'lodash/debounce'

/**
 * Images
 */

$('.woocommerce-cart').on('st-in', '.hentry', function() {
    let $article = $(this)

    // Wait for table transition
    setTimeout(() => {
        let promises = []

        $('.cart_item').each((i, el) => {
            let $el = $(el)

            promises.push(new Promise(resolve => {
                setTimeout(() => 
                    $el.imagesLoaded(() => $el.addClass('media-loaded')).always(resolve),
                    i * 1000
                )
            }))           
        })

        Promise.all(promises).then(() => 
            setTimeout(() => $article.addClass('all-media-animated'), 1000)
        ) 
    }, 3000)
})

/**
 * Quantity fields
 */

// Submit on quantity change.
$(document).on('input', '.woocommerce-cart-form .qty', _debounce(function() {
    let $form   = $(this).closest('form')
    let $submit = $form.find('[name="update_cart"]')

    if ($submit.is(':hidden')) {
        $submit.trigger('click')
    }
}, 500))